import { Box, TextField } from '@mui/material';
import { ChangeEvent } from 'react';

import {
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { ExtraBold } from './ExtraBold';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalSubtitle } from './ModalSubtitle';
import { ModalTitle } from './ModalTitle';

export const UsaEaNumberForm = () => {
  const dispatch = useAppDispatch();

  const stepInputs = useAppSelector(selectOnboardingStepInputs);
  const { value: ptin, error } = stepInputs[STEP_IDS.usaEaNumber];

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    dispatch(
      onboardingActions.updateStepInputs({
        step: STEP_IDS.usaEaNumber,
        input: value,
      }),
    );
  };

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} Subtitle={<Subtitle />} />
      <Box sx={styles.formPrimarySection}>
        <TextField
          id={'PTIN'}
          value={ptin || ''}
          onChange={handleChange}
          label="PTIN"
          variant="outlined"
          fullWidth
          error={!!error}
          helperText={
            error &&
            'Your PTIN should be an eight digit number preceded by the letter "P"'
          }
        />
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => {
  return (
    <ModalTitle>
      As an <ExtraBold>EA</ExtraBold> in the{' '}
      <ExtraBold>United States of America</ExtraBold>, what is your Preparer Tax
      Identification Number?
    </ModalTitle>
  );
};

const Subtitle = () => (
  <ModalSubtitle>
    It is important that you enter the correct information for us to receive and
    report accurate certificates.
  </ModalSubtitle>
);
